export default "__VITE_ASSET__C9n_yBsL__"